import { Directive, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { fromEvent, ReplaySubject, takeUntil } from 'rxjs';

@Directive({
  selector: '[appShowMoreItems]',
  standalone: false,
})
export class ShowMoreItemsDirective implements AfterViewInit, OnDestroy {
  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor(private elementRef: ElementRef) {
    fromEvent(window, 'resize')
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.matchWidth();
      });
  }

  public ngAfterViewInit(): void {
    this.matchWidth();
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  private matchWidth() {
    const rowNumber = 1.5;
    const container = this.elementRef.nativeElement as HTMLElement;
    const containerWidth = container.getBoundingClientRect().width;
    const badges = container.querySelectorAll('.feature-badge') as NodeListOf<HTMLElement>;
    let totalWidth = 0;
    let surplusCount = 0;

    badges.forEach((badge: HTMLElement) => {
      totalWidth += badge.offsetWidth;
      if (totalWidth > containerWidth * rowNumber) {
        surplusCount++;
        badge.classList.add('more-items');
      }
    });

    if (surplusCount > 0) {
      if (container.querySelectorAll('.plus-badge')) {
        Array.from(document.querySelectorAll('.plus-badge')).forEach((el) => el.remove());
      }
      const moreItemsSpan = document.createElement('div');
      moreItemsSpan.textContent = `+${surplusCount}`;
      moreItemsSpan.classList.add('more-items');
      moreItemsSpan.classList.add('plus-badge');
      moreItemsSpan.style.backgroundColor = '#eef0fe';
      moreItemsSpan.style.color = '#0c58c6';
      moreItemsSpan.style.padding = '0px 5px';
      moreItemsSpan.style.borderRadius = '5px';
      container.appendChild(moreItemsSpan);
    }
  }
}
